module.exports = __webpack_public_path__ + "img/ti3.dd84aba2.png";